export default __webpack_public_path__ + "static/media/down-arrow1.65766efb.svg";